<script>
import Confirmation from '@/components/widgets/modals/Confirmation'
export default {
  components: { Confirmation },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    camera: {
      type: Array,
      default: null
    },
    maxCamera: {
      type: Number,
      default: null
    },
    indexStart: {
      type: Number,
      default: null,
    },
    region: {
      type: String,
      default: 'SG'
    },
  },
  data() {
    return {
      form: {
        command: null
      },
      modalConfirm: false,
      cameraStr: '',
      cameraData: [], // Copy data camera untuk editing
      fields: [
        { key: 'enabled', label: '' },
        { key: 'cameraLabel', label: 'Camera' }
      ]
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        // Reset data di watch, cukup emit event saja
        this.$emit('update:modal', newVal)
      }
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(newVal) {
        this.$emit('update:isLoading', newVal)
      }
    },
  },
  watch: {
    // Watch modal untuk initialize/reset data saat modal dibuka
    modal: {
      handler(newVal) {
        if (newVal && this.camera && this.camera.length > 0) {
          // Deep clone array dari parent saat modal dibuka
          this.$nextTick(() => {
            this.cameraData = JSON.parse(JSON.stringify(this.camera))
          })
        } else if (!newVal) {
          // Reset saat modal ditutup
          this.cameraData = []
        }
      },
      immediate: true  // Trigger saat watcher dibuat
    },
    // Watch camera prop untuk update cameraData jika parent berubah
    camera: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          if (!this.showModal) {
            // Hanya update jika modal tidak sedang terbuka
            this.cameraData = JSON.parse(JSON.stringify(newVal))
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    // Failsafe: jika ada camera data saat component mount, langsung clone
    if (this.camera && this.camera.length > 0) {
      this.cameraData = JSON.parse(JSON.stringify(this.camera))
    }
  },
  methods: {
    handleSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();

      const statusTextArr = []
      // Gunakan cameraData (copy) bukan camera (parent)
      this.cameraData.forEach(element => {
        if (element.enabled) statusTextArr.push(element.camera)
      });
      this.cameraStr = statusTextArr.toString()
      this.modalConfirm = true
    },
    afterConfirm() {
      const payload = {
        camera: this.cameraStr
      }
      this.$emit('submit', { endpoint: this.endpoint, payload })
    }
  }
}
</script>
<template>
  <div>
    <b-modal v-model="showModal" class="mc-modal" id="modal-form" title="Set Camera" size="md" centered
      :hide-header-close="loading" no-close-on-backdrop>
      <div class="table-responsive my-3 border border-1">
        <b-table small show-empty :empty-text="$t('global.emptyTable')" :items="cameraData" :fields="fields">
          <template #cell(enabled)="data">
            <b-form-checkbox v-model="data.item.enabled"></b-form-checkbox>
          </template>
        </b-table>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button @click="handleSubmit" variant="primary" :disabled="loading">
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Kirim' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <confirmation v-if="modalConfirm" :modal.sync="modalConfirm" message="Yakin ingin mengganti setelan kamera device?"
      @confirmed="afterConfirm" />
  </div>
</template>